import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Tabs } from '@independent-software/typeui/controls/Tabs';
import { ToastService } from '@independent-software/typeui/controls/Toast';
import { Flex } from '@independent-software/typeui/controls/Flex';
import { Header } from '@independent-software/typeui/controls/Header';
import { Datum } from '@independent-software/typeui/formatters/Datum';
import { Label } from '@independent-software/typeui/controls/Label';

import { AuthContext } from '../../AuthContext';
import { FilterContext } from '../../FilterContext';
import { Section, Viewer } from '../../modules';
import { Sample, SampleFactory, Result } from '../../resource/'; 
import { Output } from '../../controls/Output';
import { TidalSituation } from '../Campaign/TidalSituation';
import { ListResults } from '../Result';

const ViewSample = () => {
  const auth = React.useContext(AuthContext);
  const filter = React.useContext(FilterContext);
  const { id } = useParams();
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(`/samples/edit/${parseInt(id)}`);
  }

  const handleDelete = () => {
    ToastService.toast("Sample deleted.");
    navigate('/samples');
  }    

  const handleResultClick = (item: Result) => {
    navigate(`/results/${item.id}`);
  }

  return (
    <Viewer<Sample> 
      auth={auth}
      id={parseInt(id)}
      factory={SampleFactory}
      canEdit='can_edit_samples'
      canDelete='can_delete_samples'
      onEdit={handleEdit}
      onDelete={handleDelete}
      content={(sample: Sample) => 
        <>
          <Section dark padded>
            <Header size="h2"><Label>{sample.station.name}</Label> <Label>{sample.campaign.name}</Label> <Label><Datum.ShortDate value={sample.date}/></Label> {sample.time && <Label><Datum.Time value={sample.time}/></Label>}</Header>
          </Section>
          <Tabs underlined>
            <Tabs.Pane label="General">
              <Section padded="very">
                <Flex.Columns count={2}>
                  <Output label="Campaign" hint="Campaign">{sample.campaign.name}</Output>
                  <Output label="Station" hint="Station">{sample.station.name}</Output>
                  <Output label="Date" hint="Date of sample"><Datum.LongDate value={sample.date}/></Output>
                  <Output label="Depth" hint="Depth from surface at which sample is collected" unit="m">{sample.depth}</Output>
                </Flex.Columns>
              </Section>
            </Tabs.Pane>
            <Tabs.Pane label="Data">
              <Section padded="very">
                <Flex.Columns count={2}>
                  <Output label="Time" hint="Time of sample"><Datum.Time seconds value={sample.time}/></Output>
                  <Output label="Sampling interval" hint="Time taken to collect the sample" unit="min">{sample.interval}</Output>
                  <Output label="Tidal situation" hint="Tide condition">{TidalSituation.toName(sample.tidal_situation)}</Output>
                  <Output label="Depth type" hint="Sampling position (e.g. surface, mid-water, bottom)">{sample.depth_type}</Output>
                </Flex.Columns>
              </Section>
            </Tabs.Pane>              
            <Tabs.Pane label="Results">
              <ListResults sampleId={sample.id} name="sample_results" auth={auth} filter={filter} onClick={auth.hasRight('can_view_results') && handleResultClick}/>
            </Tabs.Pane>
          </Tabs>
        </>}>
    </Viewer>
  );
}

export { ViewSample }
